module.exports = __webpack_public_path__ + "img/editItem.8b314414.gif";